var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-tooltip",
    {
      attrs: { bottom: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function({ on }) {
            return [
              _c(
                "router-link",
                {
                  staticStyle: { "text-decoration": "none" },
                  attrs: {
                    to: {
                      name: _vm.ACTIONPLAN_ACTIONS_LIST_ROUTE_NAME,
                      params: { actionplanId: _vm.actionPlanId }
                    }
                  }
                },
                [
                  _c(
                    "v-chip",
                    _vm._g(
                      _vm._b(
                        {
                          staticStyle: { cursor: "pointer" },
                          attrs: { small: "", "text-color": "opposite" },
                          on: {
                            click: function($event) {
                              return _vm.$emit("click")
                            }
                          }
                        },
                        "v-chip",
                        _vm.$attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _vm._v(
                        "\n        N°" + _vm._s(_vm.actionPlanId) + "\n      "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "\n    " +
            _vm._s(_vm.generateMessage("actionplans.item.link")) +
            "\n  "
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }